export default __webpack_public_path__ + "static/media/fb.ea1b208d.svg";